import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { MUser } from '../../models/auth.model'
import { IRootStates } from '../../models/store.model'
import MenuLists from './MenuLists'

interface ISidebar {
    user?: MUser
}

function Sidebar(props: ISidebar) {
    // core section
    const { user } = props
    const history = useHistory()

    // functions section
    const profileClicked = () => {
        history.push('/settings')
    }

    return (
        <div className="client-sidebar">
            <div className="profile">
                <img
                    className="profile-background"
                    src={
                        require('../../assets/images/profile_background.png')
                            .default
                    }
                    alt="profile-background"
                />
                <div className="user-info">
                    <img
                        className="img-profile"
                        src={
                            user?.profile?.profileImage ||
                            require('../../assets/images/default_avatar.png')
                                .default
                        }
                        alt="img-profile"
                        onClick={profileClicked}
                    />
                    <div className="user-name">
                        <div className="fist-name">
                            {user?.profile?.firstName}
                        </div>
                        <div className="last-name">
                            {user?.profile?.middleName}
                            {user?.profile?.middleName ? ', ' : ''}
                            {user?.profile?.lastName}
                        </div>
                    </div>
                </div>
            </div>
            <div className="menu-list">
                <MenuLists />
            </div>
        </div>
    )
}

const mapStateToProps = (store: IRootStates) => {
    const { user } = store.auth
    return {
        user,
    }
}

export default connect(mapStateToProps, null)(Sidebar)
